import { HiOutlinePlusCircle, HiOutlineTrash } from "react-icons/hi";
import { HiOutlineMinusCircle } from "react-icons/hi";
import "./CartCardComponentStyles.css"
import { useTheme } from "../../../hooks/ThemeContext";
import React from "react";

type Props = {
    currencySymbol: string,
    cartItem: any,
    mainProduct: any,
    additionalProducts?: any,
    selectedChoices: any,
    totalPrice: number,
    quantity: number,
    additionalRequests?: string,
    updateQuantity?: any,
}

const CartCardComponent = (props: Props) => {

    const { theme } = useTheme();

    const isLightBackground = (color: string): boolean => {
        const tempDiv = document.createElement('div');
        tempDiv.style.backgroundColor = color;
        document.body.appendChild(tempDiv);
        const rgbColor = window.getComputedStyle(tempDiv).backgroundColor;
        document.body.removeChild(tempDiv);
        
        const matches = rgbColor.match(/\d+/g);
        if (!matches || matches.length < 3) {
          console.warn('Failed to parse color:', color);
          return true;
        }
        
        const [r, g, b] = matches.map(Number);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.5;
    };

    // Get appropriate icon colors based on background
    const getIconColors = () => {
        const isLight = isLightBackground(theme.cartCardColor);
        return {
        active: isLight ? '#000000' : '#ffffff',
        disabled: isLight ? '#cccccc' : '#666666'
        };
    };

    const iconColors = getIconColors();

    // Loyalty reward line: paid in points at checkout — fixed quantity of 1,
    // no money price. Removable like any line (nothing is spent until payment).
    const reward = props.cartItem?.loyaltyReward;

    // Separate main product choices from add-on choices
    const mainChoices = props.selectedChoices?.filter((choice: any) => !choice.parent) || [];
    const addonChoices = props.selectedChoices?.filter((choice: any) => choice.parent) || [];

    // Group add-on choices by parent
    const addonChoicesByParent = addonChoices.reduce((acc: any, choice: any) => {
        if (!acc[choice.parent]) {
            acc[choice.parent] = [];
        }
        acc[choice.parent].push(choice);
        return acc;
    }, {});

    return (
        <div style={{marginTop: "10px", backgroundColor: theme.cartCardColor, color: theme.cartTextColor, borderRadius: "15px", userSelect: "none"}}>

            { props.updateQuantity && reward && <div style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginBottom: "1px", alignItems: "center", padding: "10px"}}>
                <span style={{fontSize: "small", fontWeight: 800, color: iconColors.active}}>⭐ Reward</span>
                <div className="product-control-buttons">
                    <span onClick={() => {props.updateQuantity(props.cartItem, 0)}} className="cart-icon trash"><HiOutlineTrash /></span>
                </div>
            </div> }

            { props.updateQuantity && !reward && <div style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginBottom: "1px", alignItems: "center", padding: "10px"}}>

                <div className="product-quantity-buttons">
                    <span 
                        onClick={() => {
                        if (props.quantity > 1) props.updateQuantity(props.cartItem, props.quantity - 1);
                        }} 
                        className={`cart-icon ${(props.quantity < 2) ? "disabled" : ""}`}
                        style={{ color: props.quantity < 2 ? iconColors.disabled : iconColors.active }}
                    >
                        <HiOutlineMinusCircle />
                    </span>
                    <span 
                        className="cart-quantity"
                        style={{ color: iconColors.active }}
                    >
                        {props.quantity}
                    </span>
                    <span 
                        onClick={() => {
                        props.updateQuantity(props.cartItem, props.quantity + 1);
                        }} 
                        className="cart-icon"
                        style={{ color: iconColors.active }}
                    >
                        <HiOutlinePlusCircle />
                    </span>
                </div>

                <div className="product-control-buttons">
                    <span onClick={() => {props.updateQuantity(props.cartItem, 0)}} className="cart-icon trash"><HiOutlineTrash /></span>
                </div>
            </div> }

            { !props.updateQuantity && <div style={{paddingTop: "20px"}} />}


        <div style={{border: "none", width: "100%", paddingLeft: "10px", paddingRight: "10px", paddingBottom: "10px", boxSizing: "border-box"}} >
        
            
            <div style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left"}}>
                <div style={{display: "flex", flexGrow: "1", flexDirection: "column", textAlign: "left"}}>
                    <span style={{fontWeight: "bold"}}> {props.mainProduct.productName}</span>

                </div>
                <br />
                <span style={{fontSize: "small", fontWeight: "bold"}}>
                    {reward ? `${Number(reward.points).toLocaleString()} pts` : props.currencySymbol + (Math.round(props.quantity * props.totalPrice * 100) / 100).toFixed(2)}
                </span>
            </div>

            {!reward && <div style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginTop: "8px", marginLeft: "10px"}}>
                <div style={{display: "flex", flexGrow: "1", flexDirection: "column", textAlign: "left"}}>
                    <span style={{fontSize: "small"}}>{props.quantity} x Base ({props.currencySymbol + (Math.round(props.mainProduct.productPrice * 100) / 100).toFixed(2)})</span>

                </div>
                <br />
                <span style={{fontSize: "small"}}>{props.currencySymbol + (Math.round(props.quantity * props.mainProduct.productPrice * 100) / 100).toFixed(2)}</span>
            </div>}
            {reward && <div style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginTop: "8px", marginLeft: "10px"}}>
                <span style={{fontSize: "small", opacity: 0.8}}>Redeemed with points — {Number(reward.points).toLocaleString()} points at checkout</span>
            </div>}

            {/* Display main product choices (choices without parent) */}
            {mainChoices.map((choice: any, index: any) => {
                return (
                    <div key={index} style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginTop: "8px", marginLeft: "10px"}}>
                        <div style={{display: "flex", flexGrow: "1", flexDirection: "column", textAlign: "left"}}>
                            <span style={{fontSize: "small"}}>{choice.name}: {choice.value}</span>
                        </div>
                    </div>
                )
            })}

            {/* Display add-ons with their choices nested below them */}
            {props.additionalProducts.map((product: any, index: any) => {
                const addonChoicesForThis = addonChoicesByParent[product.productId] || [];
                
                return (
                    <div key={index}>
                        {/* Add-on product name and price */}
                        <div style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginTop: "8px", marginLeft: "10px"}}>
                            <div style={{display: "flex", flexGrow: "1", flexDirection: "column", textAlign: "left"}}>
                                <span style={{fontSize: "small"}}>{product.productName} ({props.currencySymbol + (Math.round(product.productPrice * 100) / 100).toFixed(2)})</span>
                            </div>
                            <br />
                            <span style={{fontSize: "small"}}>{props.currencySymbol + (Math.round(props.quantity * product.productPrice * 100) / 100).toFixed(2)}</span>
                        </div>

                        {/* Add-on choices indented with dash */}
                        {addonChoicesForThis.length > 0 && (
                            <div style={{marginLeft: "20px"}}>
                                {addonChoicesForThis.map((choice: any, choiceIndex: any) => (
                                    <div key={choiceIndex} style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginTop: "4px", marginLeft: "10px"}}>
                                        <div style={{display: "flex", flexGrow: "1", flexDirection: "column", textAlign: "left"}}>
                                            <span style={{fontSize: "small"}}>- {choice.name}: {choice.value}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )
            })}

            { props.additionalRequests && 

                <div style={{display: "flex", flexGrow: "1", flexDirection: "row", textAlign: "left", marginTop: "8px", marginLeft: "10px", marginRight: "10px"}}>
                    <div style={{display: "flex", flexGrow: "1", flexDirection: "column", textAlign: "left"}}>
                        <span style={{fontWeight: 800, fontSize: "small", marginBottom: "5px"}}>Additional Requests</span>
                        <span style={{fontSize: "small"}}>{props.additionalRequests}</span> 

                    </div>
                </div>
            
            }

            { !props.updateQuantity && <div style={{paddingBottom: "10px"}} />}


        </div>

        </div>
    )
}

export default CartCardComponent;